
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contacts/bin",
      function () {
        return require("private-next-pages/contacts/bin/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contacts/bin"])
      });
    }
  